module.exports = __webpack_public_path__ + "img/intro_fact_3.fb69a1f7.svg";